import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';

const APP_META = {
  gmail:        { icon: '✉️', iconBg: 'rgba(234,67,53,0.08)', iconColor: '#EA4335', scopes: ['Send', 'Read', 'Draft'] },
  googlecalendar: { icon: '📅', iconBg: 'rgba(66,133,244,0.08)', iconColor: '#4285F4', scopes: ['Events', 'Free Slots'] },
  googledrive:  { icon: '📁', iconBg: 'rgba(15,157,88,0.08)', iconColor: '#0F9D58', scopes: ['Files', 'Folders', 'Share'] },
  googledocs:   { icon: '📄', iconBg: 'rgba(66,133,244,0.08)', iconColor: '#4285F4', scopes: ['Create', 'Edit', 'Export'] },
  googlesheets: { icon: '📊', iconBg: 'rgba(15,157,88,0.08)', iconColor: '#0F9D58', scopes: ['Read', 'Write', 'Append'] },
};

const DEFAULT_META = { icon: '🔗', iconBg: 'rgba(0,0,0,0.06)', iconColor: '#666', scopes: [] };

export default function useComposioApps() {
  const [apps, setApps] = useState([]);
  const [statuses, setStatuses] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [appsData, connections] = await Promise.all([
        api.getComposioApps(),
        api.getComposioConnections(),
      ]);

      const appList = (appsData?.apps || []).map(a => ({
        ...a,
        ...(APP_META[a.key] || DEFAULT_META),
      }));
      setApps(appList);

      const newStatuses = {};
      for (const a of appList) {
        newStatuses[a.key] = { connected: false, status: 'NOT_CONNECTED', connection_id: null };
      }
      for (const conn of connections) {
        if (conn.app && newStatuses[conn.app] !== undefined && conn.status === 'ACTIVE') {
          newStatuses[conn.app] = {
            connected: true,
            status: conn.status,
            connection_id: conn.id,
          };
        }
      }
      setStatuses(newStatuses);
    } catch (e) {
      console.error('Failed to load Composio apps/connections:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { apps, statuses, loading, reload: load };
}
